import { Message, StatelessMessage, SharedMessage, setSendFunction, ClearMessageState, SharedStatelessMessage } from "./messageBase";
import { deepClone } from "./deepClone";
import { MessageStateManager, getMsgState } from "./messageState";
import { msgSubscribers, pendingMessages, PendingMessage, resolveAbstractMessages } from "./messageSubscriber";
let messageStateManager = new MessageStateManager();
let debug = false;
let trace = true;
let debugMessages = [];
let excludeDebugMessages = [];
let messageHandlingTimeout = 3000;
export function initSMS(_debug, _debugMessages, _excludeDebugMessages) {
    debug = _debug;
    debugMessages = _debugMessages;
    excludeDebugMessages = _excludeDebugMessages || [];
    if (_excludeDebugMessages.length > 0)
        console.warn("Exlude from debugging: " + _excludeDebugMessages.join(','));
}
setSendFunction(send);
function writeDebug(pendingMsg) {
    if (debug
        && pendingMsg.type != ClearMessageState
        && (debugMessages.length == 0 || debugMessages.indexOf(pendingMsg.type.name) > -1)
        && (excludeDebugMessages.indexOf(pendingMsg.type.name) == -1)) {
        let groupName = pendingMsg.type.name;
        if (pendingMsg.isClearing == true) {
            groupName = ClearMessageState.name + `<${groupName}>`;
        }
        let color = "green";
        let isStateless = false;
        if (pendingMsg.subject instanceof StatelessMessage) {
            color = "darkorange";
            isStateless = true;
        }
        console.groupCollapsed(`%c[SMS]: ${groupName}`, "color: " + color);
        if (!isStateless)
            console.log("previous subject :", pendingMsg.previousSubject);
        console.log("subject :", pendingMsg.subject);
        console.log("subscribers :", pendingMsg.subscribers.map(s => ({ func: s.handler, ctx: s.handlerCtx })));
        if (trace) {
            console.groupCollapsed('TRACE');
            console.trace();
            console.groupEnd();
        }
        console.groupEnd();
    }
}
async function handleSubscribers(subscr, subj) {
    let proms = subscr.map(subs => subs.handle(subj));
    let t = null;
    if (debug) {
        t = setTimeout(() => {
            console.groupCollapsed(`%c[SMS]: Message handeling takes too long: ${subj.constructor.name}`, "color: #df6d6d; font-weight: bold; background-color: #290000;");
            console.log(subj);
            console.log(subscr);
            console.log(proms);
            if (trace) {
                console.groupCollapsed('TRACE');
                console.trace();
                console.groupEnd();
            }
            console.groupEnd();
        }, messageHandlingTimeout);
    }
    await Promise.all(proms);
    if (debug && t !== null)
        clearTimeout(t);
    return proms.length;
}
let messagePromises = new Map();
export function messageSent(msg) {
    if (messagePromises.has(msg))
        return messagePromises.get(msg);
    else
        return Promise.resolve();
}
export function isPending(msg) {
    return messagePromises.has(msg);
}
export async function send(subject) {
    if (!subject)
        return;
    if (!(subject instanceof Message)) {
        throw Error(Object.getPrototypeOf(subject).constructor.name + " is not instance of " + Message.name);
    }
    else {
        let sentPromResolve;
        let sentProm = new Promise((res) => { sentPromResolve = res; });
        let subjCtor = subject.constructor;
        if (messagePromises.has(subjCtor))
            await messagePromises.get(subjCtor);
        messagePromises.set(subjCtor, sentProm);
        let statelessSubject = subject instanceof StatelessMessage;
        let mutableSubject = subject instanceof SharedMessage || subject instanceof SharedStatelessMessage;
        let subjectToHandle = mutableSubject ? subject : deepClone(subject);
        resolveAbstractMessages(subjCtor);
        let pendingMessage = new PendingMessage(subject);
        pendingMessage.previousSubject = getMsgState(subjCtor);
        pendingMessage.sent = sentProm;
        pendingMessages.push(pendingMessage);
        if (subject["__isEmpty"] == true) {
            pendingMessage.subject = null;
            pendingMessage.isClearing = true;
            subject = null;
        }
        if (subject instanceof ClearMessageState) {
            let emptyMsg = new subject.subject();
            emptyMsg["__isEmpty"] = true;
            send(emptyMsg);
        }
        handleSubscribers(pendingMessage.subscribers, subject)
            .then((handledSubscribers) => {
            pendingMessage.handledCallback();
            if (!statelessSubject && subject != null) {
                messageStateManager.set(subjectToHandle);
            }
            if (subject == null) {
                messageStateManager.delete(subjCtor);
            }
            writeDebug(pendingMessage);
            let mpSent = messagePromises.get(pendingMessage.type);
            if (mpSent === pendingMessage.sent)
                messagePromises.delete(pendingMessage.type);
            mpSent = null;
            let ind = pendingMessages.indexOf(pendingMessage);
            pendingMessages.splice(ind, 1);
            pendingMessage = null;
            sentPromResolve(handledSubscribers);
            return handledSubscribers;
        });
        return sentProm;
    }
}
try {
    let self = this || window;
    if (self &&
        ((self.constructor.toString() == "[object Window]" || self.constructor.name.toLowerCase() == "window")
            || (self instanceof WorkerGlobalScope))) {
        self["SMS"] = self["SMS"] || {};
        self["SMS"].getSubscribers = () => msgSubscribers;
        self["SMS"].getPendingMessages = () => pendingMessages;
        self["SMS"].stopDebugging = () => debug = false;
        self["SMS"].startDebugging = () => debug = true;
        self["SMS"].stopTracing = () => trace = false;
        self["SMS"].startTracing = () => trace = true;
    }
}
catch (_a) { }
